import { render, staticRenderFns } from "./Planes.vue?vue&type=template&id=b2c72360&scoped=true"
import script from "./Planes.vue?vue&type=script&lang=js"
export * from "./Planes.vue?vue&type=script&lang=js"
import style0 from "./Planes.vue?vue&type=style&index=0&id=b2c72360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c72360",
  null
  
)

export default component.exports